import React from "react";
import RoleManager from "./RoleManager";
import PageWrapper from "../../components/common/PageWrapper";

const RbacManagement: React.FC = () => {
  return (
    <PageWrapper>
      <div className="space-y-6">
        {/* Header */}
        <div className="bg-white shadow rounded-lg">
          <div className="px-6 py-4">
            <h1 className="text-2xl font-bold text-gray-900">
              Role Management
            </h1>
            <p className="text-gray-600 mt-1">
              Manage role permissions to control feature access. Users are assigned roles when created or edited.
            </p>
          </div>
        </div>

        {/* Content */}
        <div className="bg-gray-50 min-h-screen">
          <RoleManager />
        </div>
      </div>
    </PageWrapper>
  );
};

export default RbacManagement;
